<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-type-titlepage element-with-heading" id="title-page">
<div class="title-page-title-subtitle-block">
<h1 class="title-page-title">The Camera Lies</h1>
</div>
<div class="title-page-contributor-block">
<div class="title-page-contributor-primary-block">
<h2 class="title-page-contributor title-page-contributor-primary title-page-contributor-without-introduction"><span class="title-page-contributor-name">AB Morgan</span></h2>
</div>
</div>
<div class="publisher-block">
<div class="title-page-publisher-logo-size-container title-page-publisher-logo-size-container-aspect-wide">
<img alt="Bloodhound Books" class="title-page-publisher-logo" src="images/bloodhoundlogocaviar-1.jpg"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?5731bc88